<ng-container *hasPermission="['READ', 'trip']">
  @if ($isEditing() && !routingService.$isMobile()) {
    <chart-config
      (unitEmit)="updateUnit($event)"
      (updateConfigEmit)="updateDataEvent($event)"
      (periodEmit)="setPeriodEvent($event)"
      [cameFromService]="cameFromService"
      [index]="index"
      (resetServiceEmit)="resetServices($event)"
      (changeServiceEmit)="changeService($event)"
      (updateCompareEmit)="updateCompareData($event)"></chart-config>
  }

  @if (noData) {
    <a class="star-message">{{ 'CHART.NO_DATA' | translate }}</a>
  }

  <div class="options-card">
    @if (isEditDash) {
      <mat-icon
        (click)="destroy()"
        style="color: var(--text-error)"
        [matTooltip]="'COMMON.DELETE' | translate">
        delete
      </mat-icon>
    } @else {
      @if (!config.compare) {
        <button matMiniFab color="primary" [matTooltip]="'COMMON.SORT' | translate" (click)="sortData()">
          <mat-icon [class]="isSortedData ? 'normal' : 'rotated'">signal_cellular_alt</mat-icon>
        </button>
      }
      @if (!routingService.$isMobile()) {
        <button
          matMiniFab
          color="primary"
          (click)="resize(!fullscreen)"
          [matTooltip]="(fullscreen ? 'COMMON.SHRINK' : 'COMMON.EXPAND') | translate">
          <mat-icon>{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <button matMiniFab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      }
    }
    <mat-menu #menu="matMenu">
      @if (!$isEditing()) {
        <button mat-menu-item (click)="editChart()">{{ 'COMMON.EDIT_BIS' | translate }}</button>
      }
      <button mat-menu-item (click)="exportGraph()">{{ 'CHART.EXPORT' | translate }}</button>
      <button mat-menu-item (click)="getState(index)">{{ 'CHART.PRINT' | translate }}</button>
    </mat-menu>
  </div>

  @if (config) {
    <h1 class="title-dashboard">
      <span [style.color]="colorsGraph[config.y]">
        {{ labelsGraph[config.y] ? labelsGraph[config.y] : ('COMMON.NO_INFORMATION' | translate) }}
      </span>
      <span>
        {{ (config.uid_service ? 'DATE.FROM' : 'DATE.FROM_TER') | translate }}
      </span>
      @if (!!$unitsById() && !!$unitsById()[config.uid_service] && !!config.uid_service) {
        <span>
          {{ $unitsById()[config.uid_service].label }}
        </span>
      } @else {
        <span>{{ 'CHART.GLOBAL_FLEET' | translate }}</span>
      }
    </h1>
  }

  @if (fullscreen) {
    <ng-container [ngTemplateOutlet]="breakingInfo" />
  }
  @if (!config.compare) {
    <div class="card-dates">
      <p>
        {{ from * 1000 | dynamicDate: 'shortDate' }} -
        {{ to * 1000 | dynamicDate: 'shortDate' }}
      </p>
    </div>
  }

  @if ($isReadyDisplay()) {
    <div [class]="fullscreen ? 'chart-fullscreen' : 'chart-wrapper'">
      <div class="canvas-container">
        <canvas
          id="myCanvas{{ index }}"
          baseChart
          #baseChart="base-chart"
          [data]="chartData"
          [options]="chartOptions"
          [type]="chartType"></canvas>
      </div>
    </div>
    @if (!fullscreen) {
      <ng-container [ngTemplateOutlet]="breakingInfo" />
    }
  } @else {
    @if (!noData) {
      <div class="widget-content-height">
        <widget-loader />
      </div>
    }
  }
</ng-container>
@if (!permissionService.checkPermissionValue({ permission: 'READ', tab: 'trip' })) {
  <div class="container-allowed">
    <p class="not-allowed-text">
      {{ 'USER.NOT_ACCESS_DATA' | translate }}
      <br />
      {{ 'USER.PLEASECONTACTADMIN' | translate }}
    </p>
  </div>
}

<ng-template #breakingInfo>
  <div class="card-dates">
    @if (config.y === 'engine' && timeBreaking && breaking) {
      <p>
        {{ 'CHART.RUPTURE_BY' | translate }} {{ breaking[config.group] | lowercase }}
        {{ 'CHART.OVER' | translate }} {{ timeBreaking[config.period] }} {{ 'CHART.IN' | translate }}
        {{ unit }}
      </p>
    } @else {
      @if (timeBreaking && breaking) {
        <p>
          {{ 'CHART.RUPTURE_BY' | translate }} {{ breaking[config.group] | lowercase }}
          {{ 'CHART.OVER' | translate }}
          {{ timeBreaking[config.period] }}
        </p>
      }
    }
  </div>
</ng-template>
